import React from "react";
import {
  CardsList,
  SectionContent,
  Text,
  WidgetCardsContainer,
} from "../../../../components";
import { applyKey } from "../../../../utils";
import * as S from "./SegurosCards.Style";

const mcmvPcvaSubtitle = (
  <>
    <S.Subtitle as={Text} textType="caption">
      MCMV - Minha Casa Minha Vida
    </S.Subtitle>
    <Text textType="caption">PCVA - Programa Casa Verde Amarela</Text>
  </>
);

const SegurosCards = () => {
  return (
    <>
      <SectionContent>
        <WidgetCardsContainer>
          {applyKey(
            [
              {
                title: "Seguro Habitacional Tradicional (FGTS e SBPE)",
                subtitle: (
                  <>
                    <S.Subtitle as={Text} textType="caption">
                      FGTS - Fundo de Garantia por tempo de Serviço
                    </S.Subtitle>
                    <Text textType="caption">
                      SBPE - Sistema Brasileiro de Poupança e Empréstimo
                    </Text>
                  </>
                ),
                path:
                  "/paravoce/habitacional/coberturas-e-assistencias/habitacional-tradicional-fgts-spbe",
              },
              {
                title: "Seguro Habitacional Tradicional (MCMV e PCVA)",
                subtitle: mcmvPcvaSubtitle,
                path:
                  "/paravoce/habitacional/coberturas-e-assistencias/habitacional-tradicional-mcmv-pcva",
              },
              {
                title: "Seguro Habitacional Mais (FGTS e SBPE)",
                subtitle: (
                  <>
                    <S.Subtitle as={Text} textType="caption">
                      FGTS - Fundo de Garantia por tempo de Serviço
                    </S.Subtitle>
                    <Text textType="caption">
                      SBPE - Sistema Brasileiro de Poupança e Empréstimo
                    </Text>
                  </>
                ),
                path:
                  "/paravoce/habitacional/coberturas-e-assistencias/habitacional-mais",
              },
              {
                title: "Seguro Habitacional Mais Premiável (MCMV e PCVA)",
                subtitle: mcmvPcvaSubtitle,
                path:
                  "/paravoce/habitacional/coberturas-e-assistencias/habitacional-mais-premiavel",
              },
            ],
            ({ title, subtitle, path }) => (
              <CardsList title={title} subtitle={subtitle} path={path} />
            )
          )}
        </WidgetCardsContainer>
      </SectionContent>
    </>
  );
};

export default SegurosCards;
